// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd0a0276","453":"ca12475b","455":"7d7ec7eb"}[chunkId] + ".chunk.js";
};